import { render, staticRenderFns } from "./indexPagination.vue?vue&type=template&id=99300052&"
import script from "./indexPagination.vue?vue&type=script&lang=js&"
export * from "./indexPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports